import { CobaltActionBar } from '@cae/cobalt-react/components/action-bar';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import * as React from 'react';

import type { EditIdentityActionBarProps } from './EditIdentityActionBar.types';

const EditIdentityActionBar = React.memo(
  ({
    isMobile,
    isPending,
    isProfileReady,
    isDirty,
    onCloseAttempt,
    onSubmit,
  }: Readonly<EditIdentityActionBarProps>): React.ReactElement => (
    <CobaltActionBar
      position="right"
      variant="floating"
      mobile={isMobile}
      data-heap-id="edit-identity-action-bar"
      secondaryButton={
        <CobaltButton
          data-heap-id="profile-identity-cancel-btn"
          variant="secondary"
          onClick={onCloseAttempt}
          disabled={isPending}
        >
          Cancel
        </CobaltButton>
      }
      primaryButton={
        <CobaltButton
          data-heap-id="profile-identity-save-btn"
          variant="primary"
          onClick={onSubmit}
          disabled={isPending || !isProfileReady || !isDirty}
        >
          Save{isPending && <CobaltLoaderCircular size="small" />}
        </CobaltButton>
      }
    />
  )
);
EditIdentityActionBar.displayName = 'EditIdentityActionBar';

export { EditIdentityActionBar };
